// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgPrompt: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M24 12c0 6.627-5.373 12-12 12-2.123 0-4.116-.551-5.846-1.518l-3.546 1.182a.64.64 0 0 1-.833-.713l.625-3.75A11.947 11.947 0 0 1 0 12C0 5.373 5.373 0 12 0s12 5.373 12 12m-13.367 2.23a2.6 2.6 0 0 1-.375-1.372c0-1.408 1.026-2.1 1.911-2.697l.067-.045.011-.007c.693-.457 1.293-.854 1.293-1.479 0-.649-.517-1.193-1.753-1.193a3.48 3.48 0 0 0-1.669.423c-.67.362-1.545.406-2.071-.144-.476-.498-.49-1.294.072-1.693C9.23 5.233 10.637 4.8 12.124 4.8c2.9 0 4.676 1.36 4.676 3.307 0 1.737-1.214 2.574-2.27 3.265l-.063.043c-.76.526-1.421.982-1.421 1.736 0 .42-.15 1.03-.556 1.142l-.914.25c-.356.097-.751.002-.944-.312m1.446 4.97c-.99 0-1.821-.774-1.821-1.695s.832-1.696 1.82-1.696c.99 0 1.822.775 1.822 1.696 0 .92-.832 1.695-1.821 1.695"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgPrompt);
export default Memo;
